module.exports = __webpack_public_path__ + "static/media/SEDEC-min.8c7d4c53.png";